<template>
    <v-container>
        <v-layout>
            <v-flex xs4 md3>
                <v-layout mb-3>
                    <v-flex>
                        <v-menu content-class="menu-card mt-2 app-content flex"
                                min-width="450px"
                                transition="scale-transition"
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                v-model="popupFiltro">
                            <v-btn slot="activator" class="btn-default" color="dark" large outline>
                                <v-icon color="primary">lnr-funnel</v-icon>
                                <div class="pl-1">Filtrar</div>
                            </v-btn>
                            <v-layout column class="card">
                                <v-flex mb-4>
                                    <v-label>Nome da região</v-label>
                                    <v-text-field ref="textField" v-model="filtro.nome" flat solo hide-details
                                                  @keyup.enter="filtrar"></v-text-field>
                                </v-flex>

                                <v-flex>

                                    <v-layout row wrap>
                                        <v-flex mr-3>
                                            <v-label>Cep inicial</v-label>
                                            <v-text-field  ref="textField"
                                                           v-model="filtro.cep_inicio"
                                                           flat
                                                           solo
                                                           mask="#####-###"
                                                           hide-details
                                                           @keyup.enter="filtrar">
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex ml-3>
                                            <v-label>Cep final</v-label>
                                            <v-text-field  ref="textField"
                                                           v-model="filtro.cep_fim"
                                                           flat
                                                           solo
                                                           mask="#####-###"
                                                           hide-details
                                                           @keyup.enter="filtrar">
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                                <v-flex mt-3>
                                    <v-label>Gerentes</v-label>
                                    <autocomplete
                                            placeholder="Selecione os gerentes"
                                            url="admin/hierarquias/regiao/gerentes"
                                            :params="{ id_usuario: id_usuario }"
                                            v-model="filtro.gerentes"
                                            :items="gerentes"
                                            item-text="nome"
                                            item-value="id_gerente"
                                            multiple chips>
                                    </autocomplete>
                                </v-flex>

                                <v-layout mt-3 justify-center>
                                    <v-flex xs4>
                                        <v-btn class="btn-default" color="dark" outline @click="limpar">Limpar</v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn class="btn-default primary" @click="filtrar">Filtrar</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-menu>
                    </v-flex>
                    <v-flex>
                        <v-btn class="btn-default" color="primary" large :to="{name:'cadastro_regiao'}">
                            Cadastrar
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout column class="card table">
            <data-table ref="table" url="/admin/regioes"
                        :params="dtParams"
                        :filter="dtFiltro" :headers="headers">
                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.nome }}</td>
                    <td>{{ maskCEP(item.cep_inicio) }}</td>
                    <td>{{ maskCEP(item.cep_fim) }}</td>
                    <td class="text-truncate">{{ item.gerentes | agggerentes}}</td>
                    <td width="1%">
                        <v-layout>
                            <v-btn flat icon color="primary" @click="editar(item)">
                                <v-icon>ol-edit</v-icon>
                            </v-btn>
                            <v-btn flat icon color="primary" @click="excluir(item)">
                                <v-icon>ol-delete</v-icon>
                            </v-btn>
                        </v-layout>
                    </td>
                    <td width="1%">
                        <v-chip disabled v-if="item.padrao" color="primary" outline>
                            <v-icon color="primary">ol-flag</v-icon>
                            <div class="pl-1 dark--text font-weight-bold">Região Padrão</div>
                        </v-chip>
                    </td>
                </template>
            </data-table>
        </v-layout>
    </v-container>
</template>

<script>
import DataTable from '../components/DataTable'
import { alert, error, sleep } from '../plugins/helpers'
import masker from 'vue-the-mask/src/masker'
import { tokens } from 'vue-the-mask'

/**
 * @var item
 * @type {object}
 * @property {number} id_regiao
 * @property {boolean} padrao
 * @property {string} cidades_unidades
 * @property {string} cidades_unidades.cidade.nome
 * @property {string} gerentes
 */

export default {
  components: { DataTable },
  data: () => ({
    filtro: {
      nome: '',
      cidades: [],
      gerentes: []
    },
    popupFiltro: false,
    cidades: [],
    gerentes: [],
    id_usuario: '',
    id_unidade_negocio: ''
  }),
  computed: {
    headers () {
      return [
        { text: 'Nome da Região', value: 'nome' },
        { text: 'Cep inicial', value: 'cep_inicio', sortable: false },
        { text: 'Cep final', value: 'cep_fim', sortable: false },
        { text: 'Gerentes', value: 'gerentes', sortable: false },
        { value: '', sortable: false },
        { value: '', sortable: false }
      ]
    },
    dtFiltro () {
      return this.filtro
    },
    dtParams () {
      return { include: ['gerentes.hierarquia.usuario'] }
    }
  },
  filters: {
    agg: (items) => items.map((i) => i.cidade.nome).join(', '),
    agggerentes: (items) => items.map((i) => i.hierarquia.usuario.nome).join(', ')
  },
  watch: {
    popupFiltro (open) {
      if (open) {
        sleep(100).then(() => this.$refs.textField.focus())
      }
    }
  },
  methods: {
    editar (item) {
      this.$router.push({ name: 'cadastro_regiao', params: { id_regiao: `${item.id_regiao}` } })
    },
    excluir (item) {
      alert({
        text: `Tem certeza que deseja excluir a região ${item.nome}?`,
        buttons: {
          'Cancelar': () => true,
          'Excluir': () => {
            this.$http.delete(`/admin/regioes/${item.id_regiao}`).then(() => {
              alert(`Região excluída com sucesso!`)
              this.filtro = { ...this.filtro }
            }).catch(err => {
              error(err, 'Não foi possível excluir a região.')
            })
          }
        }
      })
    },
    filtrar () {
      this.popupFiltro = false
      this.filtro = { ...this.filtro }
    },
    limpar () {
      this.filtro = {
        cidades: [],
        gerentes: []
      }
      this.filtrar()
    },
    loadgerentes () {
      this.$http.get('/admin/hierarquias/regiao/gerentes', {
        params: { id_usuario: this.id_usuario }
      }).then((r) => {
        r.data.forEach(r => {
          this.gerentes.push(r)
        })
      }).catch(this.fail)
    },
    maskCEP (cep) {
      cep = cep.toString().padStart(8, '0')
      return masker(cep, '#####-###', true, tokens)
    }
  },
  mounted () {
    this.id_usuario = this.$session.get('id_usuario')
    this.id_unidade_negocio = this.$session.get('id_unidade_negocio')
    this.loadgerentes()
  }
}
</script>

<style scoped>
    .text-truncate {
        max-width: 300px;
    }
</style>
